import { RouteType } from "types/RouteType";
import decisionTrackerRoute from "./DecisionTracker/decisionTracker.Route";

const operationsRoutesList: RouteType[] = [decisionTrackerRoute];

export default operationsRoutesList;
